/**
 * Custom Javascript Code for Theme.
 *
 * @author Eberhard Lauth
 *
 */
( function ( $ ) {
    /**
     * Re-Initialize Foundation's equalizer on window.load.
     * Because equalizing doesn't work in firefox e.g. without this fix.
     */
    $( window ).load( function() {
        if ( Foundation.Equalizer.length ) {
            Foundation.reInit( 'equalizer' );
        }
    } );

    /*Set all (R) and (TM) symbols to superscript*/
    $('body :not(script)').contents().filter(function () {
        return this.nodeType === 3;
    }).replaceWith(function () {
        return this.nodeValue.replace(/[™®]/g, '<sup>$&</sup>');
    });

    /* Reveal for country selection */
    $(document).ready(function() {

        $('.reveal.site-entry-country-selection #billing_country').change(function() {
            $('.reveal.site-entry-country-selection .hide-on-selection').hide();
            $('.reveal.site-entry-country-selection p.select').hide();
            $('.reveal.site-entry-country-selection p.selected').show();
            $('.reveal.site-entry-country-selection .button.country-selection').show();
        });

        $('#site-entry-country-selection #billing_country').select2({
            width: '100%' // need to override the changed default
        });
    });

    /*Payment selection on first cart pageload*/
    $(document).ready(function() {
         if($('body').hasClass('woocommerce-cart')) {
             var lph_payment_method;
             lph_payment_method = Cookies.get('lph_payment_method');
             if (lph_payment_method === 'amazon' ) {
                 $('#payment_method_amazon_payments_advanced_express').prop('checked', true);
                 $('#lph_pay_with_amazon').show().css('display','block');
                 $('#pay_with_paypal').hide();
             } else if (lph_payment_method === 'paypal' ) {
                 //$('#payment_method_ppec_paypal').prop('checked', true);
                 $('#payment_method_ppcp-gateway').prop('checked', true);
                 $('#pay_with_paypal').show().css('display','block');
                 $('#lph_pay_with_amazon').hide();
             } else {
                 // set default
                 $('#payment_method_ppcp-gateway').prop('checked', true);
                 $('#pay_with_paypal').show().css('display','block');;
                 $('#lph_pay_with_amazon').hide();
             }
         }
    });

    /*Payment selection*/
    $(document).on('click', '#payment_method_amazon_payments_advanced, #payment_method_amazon_payments_advanced_express', function() {
        if($('#payment_method_amazon_payments_advanced_express ').is(':checked')) {
            $('#lph_pay_with_amazon').show().css('display','block');
            $('#pay_with_paypal').hide();
            Cookies.set('lph_payment_method', 'amazon', {
                expires: 1,
                path: ''
            });
        }
    });

    $(document).on('click', 'img.amazon_payments_advanced_express', function() {
        if($('#payment_method_amazon_payments_advanced_express').is(':not(:checked)')) {
            $('#payment_method_amazon_payments_advanced_express').prop('checked', true);
            $('#lph_pay_with_amazon').show().css('display','block');
            $('#pay_with_paypal').hide();
            Cookies.set('lph_payment_method', 'amazon', {
                expires: 1,
                path: ''
            });
        }
    });

    $(document).on('click', '#payment_method_ppcp-gateway', function() {
        if($('#payment_method_ppcp-gateway').is(':checked')) {
            $('#pay_with_paypal').show().css('display','block');
            $('#lph_pay_with_amazon').hide();
            Cookies.set('lph_payment_method', 'paypal', {
                expires: 1,
                path: ''
            });
        }
    });

    $(document).on('click', 'img.ppcp-gateway', function() {
        if($('#payment_method_ppcp-gateway').is(':not(:checked)')) {
            $('#payment_method_ppcp-gateway').prop('checked', true);
            $('#pay_with_paypal').show().css('display','block');
            $('#lph_pay_with_amazon').hide();
            Cookies.set('lph_payment_method', 'paypal', {
                expires: 1,
                path: ''
            });
        }
    });

    /*Show/Hide Payment Icons for Paypal*/
    $(document).ajaxComplete(function() {
        if($('body').hasClass('woocommerce-checkout')) {
            if($('#payment_method_ppcp-gateway').is(':checked')) {
                $('.paypal-info').show();
            } else {
                $('.paypal-info').hide();
            }
        }
    });

    /*Coupon Code refresh color change*/
    $(document).on('input', '#coupon_code', function() {
        if($(this).val()) {
            $('button.enter-coupon-code').addClass('code-entered');
        } else {
            $('button.enter-coupon-code').removeClass('code-entered');
        }
    });

    /* Select2 Icon Override */
    $(document).ready(function() {
        $('b[role="presentation"]').hide();
        $('.select2-selection__arrow').append('<i class="material-icons-round md-light md-arrow_downward"></i>');
    });


    /* Checkout: Greyed out "Place Order Button" until Terms are checked. */
    $(document).on('click', '.woocommerce-terms-and-conditions-wrapper label.checkbox', function() {
        if($('#terms').is(':checked')) {
            $('button#place_order').removeClass('not-ready');
        } else {
            $('button#place_order').addClass('not-ready');
        }
    });

} )( jQuery );
